import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-07f36fc5")
const _hoisted_1 = {
  key: 0,
  id: "dashboard-options-chart-options",
  type: "button",
  class: "btn btn-sm d-flex justify-content-between align-items-center dropdown-toggle me-1 position-absolute end-0 top-50 translate-middle-y translate-middle-x",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-auto-close": "outside"
}
const _hoisted_2 = { class: "overflow dropdown-menu py-0 dropstart cursor-default mt-n1 min-w-200px" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "menu-content px-6 py-4 text-start fs-6 fw-bold" }, "Chart Options", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "position-relative menu-item"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Chart Type ")
const _hoisted_7 = ["id"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-0" }, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["checked"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "position-relative menu-item"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Chart Size ")
const _hoisted_14 = ["id"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-0" }, null, -1)
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 50% ")
const _hoisted_18 = ["checked"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 100% ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)
const _hoisted_21 = { class: "menu-item" }
const _hoisted_22 = {
  key: 0,
  class: "mo-dropdown-item form-check form-switch d-flex justify-content-between align-items-center cursor-pointer metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Chart Legend ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.chartOptions.types.length > 1 || _ctx.chartOptions.isLegendAvailable || _ctx.chartOptions.isChartSizeAvailable)
      ? (_openBlock(), _createElementBlock("button", _hoisted_1, " OPTIONS "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.chartOptions.types.length > 1)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("p", {
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMouseEnter(_ctx.typesID))),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMouseLeave(_ctx.typesID))),
              class: "mo-dropdown-item dropdown-toggle d-flex flex-row justify-content-between align-items-center metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text"
            }, [
              _hoisted_6,
              _createElementVNode("ul", {
                id: _ctx.typesID,
                class: "dropdown-menu overflow-hidden position-absolute end-100 me-n4 py-0 cursor-default"
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartOptions.types, (type, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    onClick: ($event: any) => (_ctx.handleTypeChange(type)),
                    key: type + index,
                    class: "mo-dropdown-item d-flex justify-content-between align-items-center metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text ms-2"
                  }, [
                    _createElementVNode("input", {
                      class: "form-check form-check-custom form-check-solid form-check-blue m-0 me-4",
                      type: "radio",
                      role: "radio",
                      checked: _ctx.isEnabledType(type)
                    }, null, 8, _hoisted_10),
                    _createTextVNode(" " + _toDisplayString(_ctx.getSpacedString(type)), 1)
                  ], 8, _hoisted_9))
                }), 128)),
                _hoisted_11
              ], 8, _hoisted_7)
            ], 32)
          ]))
        : _createCommentVNode("", true),
      (_ctx.chartOptions.isChartSizeAvailable)
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createElementVNode("p", {
              onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMouseEnter(_ctx.sizesID))),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMouseLeave(_ctx.sizesID))),
              class: "mo-dropdown-item dropdown-toggle d-flex flex-row justify-content-between align-items-center metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text"
            }, [
              _hoisted_13,
              _createElementVNode("ul", {
                id: _ctx.sizesID,
                class: "dropdown-menu overflow-hidden position-absolute end-100 me-n4 py-0 cursor-default"
              }, [
                _hoisted_15,
                _createElementVNode("label", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSizeChange('50%'))),
                  class: "form-check-label metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text form-check form-check-custom form-check-solid d-flex justify-content-between align-items-center",
                  for: "50%"
                }, [
                  _createElementVNode("input", {
                    class: "form-check form-check-custom form-check-solid form-check-blue m-0 me-4",
                    type: "radio",
                    checked: _ctx.isEnabledSize('50%'),
                    id: "50%"
                  }, null, 8, _hoisted_16),
                  _hoisted_17
                ]),
                _createElementVNode("label", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSizeChange('100%'))),
                  class: "form-check-label metronic-dropdown-item px-6 menu-link fs-6 metronic-dropdown-text form-check form-check-custom form-check-solid d-flex justify-content-between align-items-center",
                  for: "100%"
                }, [
                  _createElementVNode("input", {
                    class: "form-check form-check-custom form-check-solid form-check-blue m-0 me-4",
                    type: "radio",
                    checked: _ctx.isEnabledSize('100%'),
                    id: "100%"
                  }, null, 8, _hoisted_18),
                  _hoisted_19
                ]),
                _hoisted_20
              ], 8, _hoisted_14)
            ], 32)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.chartOptions.isLegendAvailable)
          ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input form-check-custom form-check-blue me-4 ms-0",
                type: "checkbox",
                role: "switch",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isLegendOn = $event)),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLegendToggle && _ctx.handleLegendToggle(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.isLegendOn]
              ]),
              _hoisted_23
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_24
    ])
  ], 64))
}